import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { HomeComponent } from './components/home/home.component';
import { ProductsComponent } from './components/products/products.component';
import { CategoriesComponent } from './components/products/categories/categories.component';
import { ShowCategoryComponent } from './components/show-category/show-category.component';
import { ProductService } from './service/product.service';
import { CartModalComponent } from './components/cart-modal/cart-modal.component';
import { ShowProductComponent } from './components/show-product/show-product.component';
import { SearchComponent } from './components/search/search.component';
import { ProductCardComponent } from './components/products/product-card/product-card.component';
import { FooterComponent } from './components/footer/footer.component';
import { TrendingProductsComponent } from './components/trending-products/trending-products.component';
import { AdminProductsComponent } from './components/admin/admin-products/admin-products.component';
import { ProductModalComponent } from './components/admin/product-modal/product-modal.component';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireModule } from '@angular/fire';
import { EditProductModalComponent } from './components/admin/edit-product-modal/edit-product-modal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TruncatePipe } from './pipes/truncate.pipe';
import { SwiperModule } from 'swiper/angular';


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    HomeComponent,
    ProductsComponent,
    CategoriesComponent,
    ShowCategoryComponent,
    CartModalComponent,
    ShowProductComponent,
    SearchComponent,
    ProductCardComponent,
    FooterComponent,
    TrendingProductsComponent,
    AdminProductsComponent,
    ProductModalComponent,
    EditProductModalComponent,
    TruncatePipe
  ],
  exports: [],
  imports: [
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp({
      apiKey: "AIzaSyC2VIiXoW59ujcS8fvSNdZHWT--Ks3ZlBo",
      authDomain: "pomelo-bebes.firebaseapp.com",
      projectId: "pomelo-bebes",
      storageBucket: "pomelo-bebes.appspot.com",
      messagingSenderId: "501627781259",
      appId: "1:501627781259:web:5f03afc496b6154fc7948e",
      measurementId: "G-T0LWJC5XSB"
    }),
    AngularFireStorageModule,
    NgbModule,
    SwiperModule
  ],
  providers: [
    ProductService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
